import { AvatarSkeleton } from "@circleco/compass/components/AvatarSkeleton";
import { Skeleton } from "@circleco/compass/components/Skeleton";

import { classNames } from "@/react/helpers/twMergeWithCN";

export interface CollapsibleComposerSkeletonProps {
  className?: string;
}

export const CollapsibleComposerSkeleton = ({
  className,
}: CollapsibleComposerSkeletonProps) => (
  <div className={classNames("bg-primary sticky bottom-0 py-5", className)}>
    <div className="flex items-start gap-3">
      <AvatarSkeleton size="lg" />
      <Skeleton className="h-11 flex-1 rounded-xl" />
    </div>
  </div>
);
